// Imports
import { ChevronLeft, ChevronRight } from "lucide-react";

// Prev and Next Button
export function PrevAndNextButton({ prev, prevDisabled, next, nextDisabled }) {
  // Render
  return (
    <div className="overflow-hidden rounded-lg">
      <button
        disabled={prevDisabled}
        className="p-2 bg-brand-wool disabled:opacity-50"
        onClick={prev}
      >
        <ChevronLeft />
      </button>
      <button
        disabled={nextDisabled}
        className="p-2 bg-brand-wool disabled:opacity-50"
        onClick={next}
      >
        <ChevronRight />
      </button>
    </div>
  );
}
